import React from 'react';

export type WizardContextType<T> = {
  currentStep: T;
  goToStep: (step: T) => void;
};

export const WizardContext = React.createContext<WizardContextType<any> | null>(null);
